import React from 'react'
import './TopBar.css'
import {HiLocationMarker} from 'react-icons/hi'
import {FaFacebookF} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {FaTiktok} from 'react-icons/fa'


const TopBar = () => {
  return (
    <div className='top-bar-container'>
        
        
            <div className='location'>
                <p><HiLocationMarker/></p>
                <p>Nairobi, Kenya</p>
            </div>

            <div className='info'>
                <p>WE DELIVER COUNTRYWIDE</p>
             </div>

            <div className='socials'>
               <a href="https://web.facebook.com/login.php/?_rdc=1&_rdr" target="_blank" rel="noopener noreferrer" id="fb"><FaFacebookF/></a>
               <a href="https://www.instagram.com/uniter_njeey/" target="_blank" rel="noopener noreferrer" id="ig"><FiInstagram/> </a>
               <a href="https://www.tiktok.com/login" target="_blank" rel="noopener noreferrer" id="tiktok"><FaTiktok/></a>
            </div>
        
    </div>
  )
}

export default TopBar;